import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  page: {
    width: "100%",
  },
  headerBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
    padding: "16px 22px",
    borderBottom: "1px solid #EEF0F4",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0,
  },
  headerIconBadge: {
    width: 36,
    height: 36,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#e9f5ec",
    color: theme.palette.primary.main,
    flexShrink: 0,
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
  },
  headerTitleGroup: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    minWidth: 0,
    flexWrap: "wrap",
  },
  headerTitle: {
    fontWeight: 700,
    color: "#10212a",
    fontSize: 18,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 420,
  },
  headerReference: {
    color: "#98A2B3",
    fontSize: 14,
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  statusChip: {
    fontWeight: 600,
    fontSize: 12,
    height: 24,
    textTransform: "capitalize",
  },
  statusDraft: {
    backgroundColor: "#EFF6FF",
    color: "#2563EB",
  },
  statusApproved: {
    backgroundColor: "#e9f5ec",
    color: theme.palette.primary.main,
  },
  deleteButton: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    "&:hover": {
      borderColor: theme.palette.error.dark,
      backgroundColor: "rgba(255, 32, 32, 0.06)",
    },
  },
  tabsBar: {
    borderBottom: "1px solid #EEF0F4",
    paddingInline: 10,
    "& .MuiTab-root": {
      textTransform: "none",
      fontWeight: 600,
      minHeight: 48,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
    "& .Mui-selected": {
      color: `${theme.palette.primary.main} !important`,
    },
  },
  tabContent: {
    padding: "22px",
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
    marginBottom: 22,
  },
  statCard: {
    backgroundColor: "#f4f8f5",
    border: "1px solid #dce9df",
    borderRadius: 10,
    padding: "16px 18px",
  },
  statLabel: {
    color: "#5b6870",
    fontSize: 13,
    fontWeight: 500,
  },
  statValue: {
    marginTop: 8,
    fontWeight: 700,
    fontSize: 24,
    color: "#10212a",
  },
  statSubtext: {
    marginTop: 4,
    color: "#98A2B3",
    fontSize: 12,
  },
  contentGrid: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    gap: 16,
    alignItems: "start",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
    },
  },
  panel: {
    border: "1px solid #dce9df",
    borderRadius: 10,
    overflow: "hidden",
  },
  panelHeader: {
    padding: "14px 18px",
    borderBottom: "1px solid #EEF0F4",
    backgroundColor: "#f4f8f5",
  },
  panelHeaderText: {
    fontWeight: 700,
    color: "#10212a",
    fontSize: 15,
  },
  panelBody: {
    padding: "18px",
  },
  detailGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    columnGap: 24,
    rowGap: 18,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  fieldLabel: {
    color: "#5b6870",
    fontSize: 13,
  },
  fieldValue: {
    marginTop: 4,
    color: "#10212a",
    fontSize: 15,
    fontWeight: 500,
  },
  fieldValueMuted: {
    marginTop: 4,
    color: "#98A2B3",
    fontSize: 15,
  },
  sidePanelStack: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  riskRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  riskChip: {
    fontWeight: 600,
    fontSize: 12,
    backgroundColor: "#F2F4F7",
    color: "#344054",
  },
  riskBar: {
    marginTop: 10,
    height: 6,
    borderRadius: 999,
    backgroundColor: "#EEF0F4",
    overflow: "hidden",
  },
  riskBarFill: {
    height: "100%",
    backgroundColor: theme.palette.primary.main,
  },
  snapshotGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    columnGap: 24,
    rowGap: 18,
  },
  placeholderTab: {
    padding: "48px 16px",
    textAlign: "center",
    color: "#5b6870",
  },

  // Parties tab
  panelHeaderRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  countBadge: {
    minWidth: 20,
    height: 20,
    padding: "0 6px",
    borderRadius: 999,
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    fontSize: 12,
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  signaturesEmpty: {
    padding: "36px 16px",
    textAlign: "center",
    color: "#98A2B3",
  },

  // Documents / templates tab
  templatesHeader: {
    display: "flex",
    alignItems: "baseline",
    gap: 8,
    marginBottom: 18,
  },
  templatesTitle: {
    fontWeight: 700,
    fontSize: 16,
    color: "#10212a",
  },
  templatesCount: {
    color: "#98A2B3",
    fontSize: 13,
  },
  templatesGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
    gap: 18,
  },
  templateCard: {
    border: "1px solid #dce9df",
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
  },
  templateThumb: {
    position: "relative",
    height: 108,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    overflow: "hidden",
  },
  templateThumbRibbon: {
    position: "absolute",
    top: 0,
    right: 0,
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "0 22px 22px 0",
    borderColor: "transparent currentColor transparent transparent",
  },
  templateThumbLine: {
    width: 46,
    height: 4,
    borderRadius: 2,
    backgroundColor: "#E4E7EC",
  },
  templateThumbLineAccent: {
    width: 26,
    height: 4,
    borderRadius: 2,
  },
  templateBody: {
    padding: "14px 16px 16px",
    display: "flex",
    flexDirection: "column",
    gap: 6,
    flex: 1,
  },
  templateCategory: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#98A2B3",
  },
  templateTitle: {
    fontWeight: 700,
    fontSize: 15,
    color: "#10212a",
    lineHeight: 1.3,
  },
  templateDescription: {
    color: "#5b6870",
    fontSize: 13,
    lineHeight: 1.5,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  templateFooterRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 8,
  },
  templateMetaGroup: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  templateMetaItem: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    color: "#5b6870",
    fontSize: 12,
    "& .MuiSvgIcon-root": {
      fontSize: 15,
    },
  },
  templateStatus: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    color: theme.palette.primary.main,
    fontSize: 12,
    fontWeight: 600,
  },
  templateStatusDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
  },
  templateUsage: {
    marginTop: 10,
    color: "#98A2B3",
    fontSize: 12,
  },
  templateProgressTrack: {
    marginTop: 6,
    height: 4,
    borderRadius: 999,
    backgroundColor: "#EEF0F4",
    overflow: "hidden",
  },
  templateProgressFill: {
    height: "100%",
    backgroundColor: theme.palette.primary.main,
  },
}));

export default useStyles;
